module.exports = __webpack_public_path__ + "static/img/di4.29bc418.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/padImg/di4.png
// module id = HNfh
// module chunks = 1